const ImagePath = "/assets/images";
const GamesImagePath = `${ImagePath}/games`;
const RibbonImagePath = `${ImagePath}/ribbon`;
const ExtraImagePath = `${ImagePath}/extra`;
export const AppImages = {
  navLogo: `${ImagePath}/nav_logo.png`,
  winRibbon: `${RibbonImagePath}/outcome-state-win.png`,
  lossRibbon: `${RibbonImagePath}/outcome-state-lose.png`,
  ongoingRibbon: `${RibbonImagePath}/outcome-state-ongoing.png`,
  awaitingRibbon: `${RibbonImagePath}/outcome-state-awaiting.png`,
  voidRibbon: `${RibbonImagePath}/outcome-state-void.png`,
  tieRibbon: `${RibbonImagePath}/outcome-state-tie.png`,
  winRibbonVideo: `${RibbonImagePath}/YOUWIN.mp4`,
  gameResultRibbonVideo: `${RibbonImagePath}/gameresult-final.mp4`,
  tieRibbonVideo: `${RibbonImagePath}/YOUTIE.mp4`,
  promoBanner: `${GamesImagePath}/promo_banner_1.png`,
  radialPattern: `${ExtraImagePath}/radial_pattern.png`,
  noImageAvailable: `${ExtraImagePath}/noimageavailable.png`,
};

const SVGPath = "/assets/svg";
export const AppSVG = {
  gemIcon: `${SVGPath}/pinkgem.png`,
  gemIconPixel: `${SVGPath}/getgud-gem-icon.png`, // Pixel GEM currency icon
  rcrIcon: `${SVGPath}/getgud-coin-icon.png`, // Pixel RCR currency icon
  nhlfsCoinIcon: `${SVGPath}/nhlfs-coin.png`, // NHLFS COINS currency icon
  trending: `${SVGPath}/trending.svg`,
  questionmark: `${SVGPath}/questionmark.svg`,
  arrowRight: `${SVGPath}/arrowRight.svg`,
  restart: `${SVGPath}/restart.svg`,
};
